import type { AppFeatureList } from 'src/api/responses'

export const isSubFeatureEnabledIn = (
  features: AppFeatureList[],
  featureKey: string,
  subFeatureKey: string,
  defaultValue = false,
): boolean => {
  const featureParent = features.find(feature => feature.key === featureKey)
  if (!featureParent) {
    return defaultValue
  }
  if (!featureParent.enabled) {
    return false
  }
  const subFeature = featureParent.sub_features?.find(sub => sub.key === subFeatureKey)
  if (!subFeature) {
    return defaultValue
  }
  return subFeature.enabled
}
